import script from "./SurveyPreviewBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyPreviewBox.vue?vue&type=script&setup=true&lang=js"

import "./SurveyPreviewBox.vue?vue&type=style&index=0&id=f679948e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f679948e"]])

export default __exports__